import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M2.65 6.56a1.333 1.333 0 0 1 1.33-1.227h8.039a1.333 1.333 0 0 1 1.33 1.227l.535 6.667a1.334 1.334 0 0 1-1.33 1.44h-9.11a1.332 1.332 0 0 1-1.328-1.44L2.65 6.56Z"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M10.665 7.333V4a2.667 2.667 0 0 0-5.333 0v3.333"
    }, null, -1)
  ]))]))
}
export default { render: render }